//codex-- Keep the toolbar redesign scoped to pages in this folder.
import PageToolbar from './PageToolbar';
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import CustomTabs from '../components/CustomTabs';
import CalendarViewFDNY from '../components/CalendarViewFDNY';
import HeadingCp from '../components/HeadingCp';
import FDNYNewInspectionModal from '../components/FDNYNewInspectionModal';
import FDNYlistCp from '../components/FDNYlistCp';

const STORAGE_KEY = 'fdny:viewMode'; // 'Calendar View' | 'FDNY List View'

const FdnyInspection = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  // ✅ initialize from localStorage (fallback to Calendar View)
  const [activeLink, setActiveLink] = useState(() =>
    localStorage.getItem(STORAGE_KEY) || 'Calendar View'
  );

  const [showModal, setShowModal] = useState(false);
  const [editData, setEditData] = useState(null);

  useEffect(() => {
    fetchSomething();
  }, []);

  // ✅ whenever activeLink changes, persist it
  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, activeLink);
  }, [activeLink]);

  const fetchSomething = async () => {
    try {
      setLoading(true);
      // ... your fetch
    } catch (error) {
      if (error.response?.status === 401) {
        toast.error('Session expired', { position: 'top-center' });
        navigate('/login');
      } else {
        toast.error('Error fetching data', { position: 'top-center' });
      }
    } finally {
      setLoading(false);
    }
  };

  // ✅ setters that also update localStorage via setActiveLink + effect above
  const handleCalendarView = () => setActiveLink('Calendar View');
  const handleListView = () => setActiveLink('FDNY List View');

  const openNewInspection = () => {
    setEditData(null);
    setShowModal(true);
  };

  const openEditInspection = (row) => {
    setEditData(row);
    setShowModal(true);
  };

  const handleSubmitInspection = async (formData) => {
    if (
      formData.data.address == null ||
      formData.data.tech_inspection == null ||
      formData.data.start_time == null ||
      formData.data.jobnum == null ||
      formData.data.date == null
    ) {
      toast.error('Please fill all the required fields', { position: 'top-center' });
      return;
    }
    try {
      const response = await axios.post(`${apiUrl}/fdny_crud.php`, formData, {
        headers: { 'Content-Type': 'application/json' },
      });
      if (response.data.success) {
        toast.success('Inspection saved', { position: 'top-center' });
        setShowModal(false);
      } else {
        toast.error('Error saving inspection', { position: 'top-center' });
      }
    } catch (error) {
      console.error(error);
      toast.error('Error saving inspection', { position: 'top-center' });
    }
  };

  const tabs = [
    { label: 'Calendar View', onClick: handleCalendarView },
    { label: 'FDNY List View', onClick: handleListView },
  ];

  return (
    <>
      <div className="mx-auto max-w-6xl sm:px-6 lg:px-8 py-10">
        <HeadingCp label="FDNY Inspection" />

        <>{/*codex-- Match the updated toolbar: grouped actions, labeled controls, and lighter original colors. */}
          <PageToolbar title="FDNY inspection tools" actions={<>
            <button onClick={openNewInspection} className="bg-blue-500 hover:bg-blue-600 text-white px-2 py-1 rounded text-sm">New Inspection</button>
          </>} />
      </>

        {/* If your CustomTabs can accept the active tab, pass it for proper highlight */}
        <CustomTabs tabs={tabs} activeLabel={activeLink} />

        <br />
        {activeLink === 'Calendar View' && <CalendarViewFDNY />}
        {activeLink === 'FDNY List View' && <FDNYlistCp />}
      </div>

      <FDNYNewInspectionModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        onSubmit={handleSubmitInspection}
        initialData={editData || {}}
      />
    </>
  );
};

export default FdnyInspection;
